export default __webpack_public_path__ + "static/media/add-to-watchlist-new.2e7240f6.svg";